/**
 * The path a sign-in comes back to, read from `?next=` — `base-auth` writes that parameter
 * (`base_auth::http::LOGIN_RETURN_PARAM`) when it sends a browser to `/login`, and the router
 * writes it when a signed-out visitor reaches a guarded screen.
 *
 * A path on this origin and never a URL: a return value read back into a navigation is how a
 * sign-in screen becomes an open redirect.
 */
export function safeNext(raw: unknown): string | null {
  return typeof raw === 'string' && raw.startsWith('/') && !raw.startsWith('//') ? raw : null
}

/**
 * The roots another HTML entry of the build serves, each with a router of its own: the staff
 * console at `/staff/`. The app's router knows none of their paths and would draw its not-found
 * page for one.
 */
const OTHER_ENTRY_ROOTS = ['/staff'] as const

/**
 * Whether a return path belongs to another entry than the app's — `/staff`, `/staff/` and below,
 * with or without a query or a fragment, but not `/staffing`. A sign-in leaves for such a path by
 * a document navigation (`window.location.assign`) rather than through the app's router.
 */
export function isOtherEntry(path: string): boolean {
  return OTHER_ENTRY_ROOTS.some((root) => {
    if (!path.startsWith(root)) return false
    const rest = path.slice(root.length)
    return rest === '' || rest.startsWith('/') || rest.startsWith('?') || rest.startsWith('#')
  })
}
